<template>
    <Layout>
        <PageHeader :title="title" :items="items" :backButton="true" :prevRoutePath="backUrl"/> 
        <div class="row">
            <div class="col-lg-12 col-sm-12 mb-3">
                <div class="card p-4">
                    <div class="media">
                        <div class="avatar-sm mr-3">
                            <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                <i class="bx bx-world bx-md"></i>
                            </span>
                        </div>
                        <div class="media-body">
                            <h5 class="mt-3">{{ $t('website.website-whois-detail') }}</h5>
                        </div>
                    </div>
                    <div>
                        <div class="row mt-1">
                          <!-- <p>
                                {{SearchResult}}
                            </p> -->
                            <div class="col-sm-12">
                                  <!-- {{dataResult}} -->
                                  <hr>
                                    <div class="text-center p-5" v-if="loading">
                                        <div class="spinner-border text-secondary" role="status" v-if="loading">
                                        <span class="sr-only"><p>{{ $t('website.website-whois-detail') }}</p></span>
                                    </div>
                                </div>
                                 <p v-if="dataResult.domain_name"><b>{{ $t('website.domain_name') }}: </b> {{dataResult.domain_name}}</p>
                                 <p v-if="dataResult.created_date"><b>{{ $t('website.created_date') }}: </b> {{dataResult.created_date}}</p>
                                  <p v-if="dataResult.expired_date"><b>{{ $t('website.expired_date') }}: </b> {{dataResult.expired_date}}</p>
                                  <p v-if="dataResult.contact_email"><b>{{ $t('website.contact_email') }}: </b> {{dataResult.contact_email}}</p>
                                  <p v-if="dataResult.registran_name"><b>{{ $t('website.registran_name') }}: </b> {{dataResult.registran_name}}</p>
                                  <p v-if="dataResult.registran_organization"><b>{{ $t('website.registrant_organization') }}: </b> {{dataResult.registran_organization}}</p>
                                  <p v-if="dataResult.registran_street"><b>{{ $t('website.registran_street') }}: </b> {{dataResult.registran_street}}</p>
                                  <p v-if="dataResult.registran_city"><b>{{ $t('website.registran_city') }}: </b> {{dataResult.registran_city}}</p>
                                  <p v-if="dataResult.registran_state"><b>{{ $t('website.registran_state') }}: </b> {{dataResult.registran_state}}</p>
                                  <p v-if="dataResult.registran_postal_code"><b>{{ $t('website.registran_postal_code') }}: </b> {{dataResult.registran_postal_code}}</p>
                                  <p v-if="dataResult.registran_country"><b>{{ $t('website.registran_country') }}: </b> {{dataResult.registran_country}}</p>
                                  <p v-if="dataResult.registrant_countryCode"><b>{{ $t('website.registran_country') }}: </b> {{dataResult.registrant_countryCode}}</p>
                                  <p v-if="dataResult.registran_email"><b>{{ $t('website.registran_email') }}: </b> {{dataResult.registran_email}}</p>
                                   <p v-if="dataResult.registran_telephone"><b>{{ $t('website.registran_phone') }}: </b> {{dataResult.registran_telephone}}</p>
                                  <p v-if="dataResult.registran_fax"><b>{{ $t('website.registran_fax') }}: </b> {{dataResult.registran_fax}}</p>
                                  <p v-if="dataResult.admin_name">======================================================</p>
                                  <p v-if="dataResult.admin_name"><b>{{ $t('website.admin_name') }}: </b> {{dataResult.admin_name}}</p>
                                  <p v-if="dataResult.admin_organization"><b>{{ $t('website.admin_organization') }}: </b> {{dataResult.admin_organization}}</p>
                                  <p v-if="dataResult.admin_street"><b>{{ $t('website.admin_street') }}: </b> {{dataResult.admin_street}}</p>
                                  <p v-if="dataResult.admin_city"><b>{{ $t('website.admin_city') }}: </b> {{dataResult.admin_city}}</p>
                                  <p v-if="dataResult.admin_state"><b>{{ $t('website.admin_state_provincie') }}: </b> {{dataResult.admin_state}}</p>
                                  <p v-if="dataResult.admin_postalCode"><b>{{ $t('website.admin_postal_code') }}: </b> {{dataResult.admin_postalCode}}</p>
                                  <p v-if="dataResult.admin_host_contry"><b>{{ $t('website.admin_country') }}: </b> {{dataResult.admin_host_contry}}</p>
                                   <p v-if="dataResult.admin_countryCode"><b>{{ $t('website.admin_postal_code') }}: </b> {{dataResult.admin_countryCode}}</p>
                                  <p v-if="dataResult.admin_email"><b>{{ $t('website.admin_phone') }}: </b> {{dataResult.admin_email}}</p>
                                  <p v-if="dataResult.admin_telephone"><b>{{ $t('website.admin_phone') }}: </b> {{dataResult.admin_telephone}}</p>
                                  <p v-if="dataResult.admin_fax"><b>{{ $t('website.admin_fax') }}: </b> {{dataResult.admin_fax}}</p>
                                  <p v-if="dataResult.tech_name">======================================================</p>
                                  <p v-if="dataResult.tech_name"><b>{{ $t('website.tech_name') }}: </b> {{dataResult.tech_name}}</p>
                                  <p v-if="dataResult.tech_organization"><b>{{ $t('website.tech_organization') }}: </b> {{dataResult.tech_organization}}</p>
                                  <p v-if="dataResult.tech_street"><b>{{ $t('website.tech_street') }}: </b> {{dataResult.tech_street}}</p>
                                  <p v-if="dataResult.tech_city"><b>{{ $t('website.tech_city') }}: </b> {{dataResult.tech_city}}</p>
                                  <p v-if="dataResult.tech_state"><b>{{ $t('website.tech_state_province') }}: </b> {{dataResult.tech_state}}</p>
                                  <p v-if="dataResult.tech_postalCode"><b>{{ $t('website.tech_postal_code') }}: </b> {{dataResult.tech_postalCode}}</p>
                                  <p v-if="dataResult.tech_host_contry"><b>{{ $t('website.tech_country') }}: </b> {{dataResult.tech_host_contry}}</p>
                                  <p v-if="dataResult.tech_countryCode"><b>{{ $t('website.tech_postal_code') }}: </b> {{dataResult.tech_countryCode}}</p>
                                  <p v-if="dataResult.tech_email"><b>{{ $t('website.tech_email') }}: </b> {{dataResult.tech_email}}</p>
                                  <p v-if="dataResult.tech_telephone"><b>{{ $t('website.tech_phone') }}: </b> {{dataResult.tech_telephone}}</p>
                                  <p v-if="dataResult.tech_fax"><b>{{ $t('website.tech_fax') }}: </b> {{dataResult.tech_fax}}</p>
                            </div>
                        </div>
                    </div>
                  </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import WebsiteService from "@/helpers/website.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Tools Website",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            backUrl: '/domain-whois',
            id: this.$route.params.id,
            urlimage: 'http://localhost:8001/api/target/image-project?name=',
            loading: false,
            dataResult: {
            },
            search:false,
            title: this.$t('website.website-whois-detail'),
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                {
                text: this.$t('website.website-whois'),
                href: "/domain-whois"
                },
                {
                text: this.$t('website.website-whois-detail'),
                active: true
                }
            ],
        }
    },
    methods:{
        getWhois(){
        this.loading = true;
          WebsiteService.getWebWhoisDetail(this.id)
          .then(response => {
                    // console.log(response);
                    this.dataResult = response.data.data;
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = flase;
            });
        },
      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
  },
    mounted(){
        this.totalRows = this.items.length;
        this.getWhois();
    }
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>